<template>
  <div>
    <el-tag type="primary"
            class="text">
      <transition name="slide"
                  mode="out-in">
        <p :key="text.id">
          <i class="el-icon-s-opportunity"></i> 公告：{{text.val}}
        </p>
      </transition>
    </el-tag>
  </div>
</template>
 
<script>
export default {
    name: "TextScroll",
    props: {
        dataList: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            count: 0, // 当前索引
            intervalId: null, // 定时器ID
            playTime: 3000, // 定时器执行间隔
        };
    },
    computed: {
        text() {
            return {
                id: this.count,
                val: this.dataList[this.count],
            };
        },
    },
    created() {
        this.intervalId = setInterval(() => {
            // 定义定时器
            this.getText();
        }, this.playTime);
    },
    methods: {
        getText() {
            const len = this.dataList.length; // 获取数组长度
            if (len === 0) return; // 当数组为空时，直接返回
            this.count === len - 1 ? (this.count = 0) : this.count++;
        },
    },
    destroyed() {
        clearInterval(this.intervalId); // 清除定时器
    },
};
</script>
 
<style scoped>
.text {
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    height: 30px;
    line-height: 30px;
    text-align: left;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.7s linear;
}
.slide-enter {
    transform: translateY(15px);
    opacity: 1;
}
.slide-leave-to {
    transform: translateY(-20px);
    opacity: 0;
}
</style>